<template>
  <div class="container-fluid projects">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h3 id="projects">{{ title }}</h3>
        </div>
      </div>
      <div class="row">
        <project v-for="item in projects" :key="item.id" :project="item" @opened="onDetailsOpened"></project>
      </div>
    </div>
    <modal v-if="showProjectDetails" @close="showProjectDetails = false">
      <template v-slot:header>
        <h5 class="modal-title">{{selectedProject.content.title}}</h5>
      </template>
      <template v-slot:body>
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 col-md-8 image">
              <vueper-slides
                fade
                slide-content-outside="false"
                slide-content-outside-class="max-widthed"
                :init-slide="selectedProject.images.findIndex(e => e.master == true) + 1"
                fixed-height="100%"
                :touchable="false"
                :slide-ratio="0.3"
              >
                <vueper-slide
                  v-for="(slide, i) in selectedProject.images"
                  :key="i"
                  :image="publicPath + 'img/products/' + slide.url"
                ></vueper-slide>
              </vueper-slides>
            </div>
            <div class="col-12 col-md-4 aside">
              <div class="row">
                <div class="col-12">
                  <h3>{{ selectedProject.content.title }}</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <p>{{ selectedProject.content.description }}</p>
                </div>
              </div>
              <!-- <div class="row order">
                <div class="col-12">
                  <button class="btn btn-primary">Overiť dostupnosť</button>
                </div>
              </div>-->
            </div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Project from "./project.vue";
import Modal from "./modal.vue";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  props: {
    title: String,
    projects: Array
  },
  components: {
    Project,
    Modal,
    VueperSlides,
    VueperSlide
  },
  data: function() {
    return {
      showProjectDetails: false,
      selectedProject: null,
      publicPath: process.env.BASE_URL
    };
  },
  methods: {
    onDetailsOpened: function(item) {
      this.selectedProject = item;
      this.showProjectDetails = true;
    }
  }
};
</script>

<style lang="scss">
.agile {
  img {
    max-width: 500px;
    height: auto;
  }
}
</style>
